import './runtimeConfig'

import React from 'react'
import { render } from 'react-dom'
import { Router, Route, Redirect, Switch } from 'react-router-dom'
import createHistory from 'history/createBrowserHistory'
import UUID from 'uuid'
import { I18nextProvider } from 'react-i18next'

import DrawingBoard from './components/DrawingBoard'
import ResetPassword from './components/Accounts/reset_password'
import EmbedTest from './components/EmbedTest'

import i18n from './i18n'

render(
  <I18nextProvider i18n={i18n}>
    <Router history={createHistory()}>
      <Switch>
        <Redirect exact replace from="/" to={`/${UUID.v1()}${window.location.search}`} />
        <Route path="/reset-password/:uuid" component={ResetPassword} />
        <Route path="/:room" component={DrawingBoard} />
        <Route path="/embed/:room" component={DrawingBoard} />
        <Route path="/embed/:customer/:room" component={DrawingBoard} />
        <Route path="/embed-test/:room" component={EmbedTest} />
      </Switch>
    </Router>
  </I18nextProvider>,
  document.getElementById('main')
)



// WEBPACK FOOTER //
// ./app/app.js